import txtIcon from "./TXT.png"
import csvIcon from "./CSV.png"
import excelIcon from "./EXCEL.png"
import openFolderIcon from "./OPENFOLDER.png"
import closeFolderIcon from "./CLOSEFOLDER.png"
import docxIcon from "./DOCX.png"
import fileIcon from "./FILE.png"
import htmlIcon from "./HTML.png"
import yamlIcon from "./YAML.png"
import imageIcon from "./IMAGE.png"
import pdfIcon from "./PDF.png"

const IconBank = {
    FILE: {
        TXT: txtIcon,
        LOG: txtIcon,
        HTML: htmlIcon,
        YML: yamlIcon,
        YAML: yamlIcon,
        CSV: csvIcon,
        XLS: excelIcon,
        XLSX: excelIcon,
        XLSM: excelIcon,
        DOCX: docxIcon,
        PDF: pdfIcon,
        PNG: imageIcon,
        JPG: imageIcon,
        JPEG: imageIcon,
        DEFAULT: fileIcon,
    },
    FOLDER: { OPEN: openFolderIcon, CLOSE: closeFolderIcon },
}

const Icons = {
    icons: IconBank,
    file: (filetype) => {
        if (IconBank.FILE[filetype] === undefined) {
            return IconBank.FILE.DEFAULT
        } else {
            return IconBank.FILE[filetype]
        }
    },
    folder: (state) => {
        if (String(state).toUpperCase() === "OPEN") {
            return IconBank.FOLDER.OPEN
        } else if (String(state).toUpperCase() === "CLOSE") {
            return IconBank.FOLDER.CLOSE
        } else {
            return null
        }
    },

}

export default Icons
